import { $gt as __gt, createExpressionOperator } from "../../_predicates";
const $gt = createExpressionOperator(__gt);
export {
  $gt
};
